import React from 'react';

export default function ConversionFieldHeader(props) {
    return (
        <div className="col-12">
            <p className="flow__header-label font-weight-bold mb-0 mt-lg-3">{props?.field?.label}</p>
            <p className="flow__header-intro mt-1">{props?.field?.config?.intro}</p>
        </div>
    );
}
